export const GET_SESSION_KONSELING_REQUEST = "GET_SESSION_KONSELING_REQUEST";
export const GET_SESSION_KONSELING_SUCCESS = "GET_SESSION_KONSELING_SUCCESS";
export const GET_SESSION_KONSELING_FAIL = "GET_SESSION_KONSELING_FAIL";
export const GET_SESSION_KONSELING_RESET = "GET_SESSION_KONSELING_RESET";

export const GET_SESSION_KONSELING_STATUS_REQUEST =
  "GET_SESSION_KONSELING_STATUS_REQUEST";
export const GET_SESSION_KONSELING_STATUS_SUCCESS =
  "GET_SESSION_KONSELING_STATUS_SUCCESS";
export const GET_SESSION_KONSELING_STATUS_FAIL =
  "GET_SESSION_KONSELING_STATUS_FAIL";
export const GET_SESSION_KONSELING_STATUS_RESET =
  "GET_SESSION_KONSELING_STATUS_RESET";

export const COUNSELEE_VAR_SERVER = "Counselee";
export const COUNSELOR_VAR_SERVER = "Counselor";

export const WAITING_ROOM = "WAITING_ROOM";
export const VC_ROOM = "VC_ROOM";
export const VC_CLOSE = "VC_CLOSE";

export const PDULI_ALERT_TIME_WILL_BE_OVER = "PDULI_ALERT_TIME_WILL_BE_OVER";

export const STOP_SESSION_KONSELING_REQUEST = "STOP_SESSION_KONSELING_REQUEST";
export const STOP_SESSION_KONSELING_SUCCESS = "STOP_SESSION_KONSELING_SUCCESS";
export const STOP_SESSION_KONSELING_FAIL = "STOP_SESSION_KONSELING_FAIL";
export const STOP_SESSION_KONSELING_RESET = "STOP_SESSION_KONSELING_RESET";
